import React from 'react'
import { Link } from 'react-router-dom'
import { styled } from 'styled-components'

const PortfolioImageStyle = styled.div`
display:flex;
flex-direction:column;
align-items:center;
img{
    height: 250px;
    width: 450px;

    @media screen and (max-width: 1300px) {
        max-height: 200px;
        width: auto;
        }
        @media screen and (max-height: 900px) {
          max-height: 150px;
          width: auto;
    }
}

.name{
    margin-top: 16px;
    p{
        font-family: Raleway;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 3.249px;
    }
}

`
const PortfolioImage = ({ image, name, url }) => {
  return (
    <Link to={url && url} target={url && '_blank'}>
      <PortfolioImageStyle>
        <img src={image} alt={name} />
        <div className='name'>
          <p >{name}</p>
        </div>
      </PortfolioImageStyle>
    </Link>
  )
}

export default PortfolioImage